import { Summary, useFormContext, type StepSchema } from '@stepform';
import { MentalHealthDeclaration } from './MentalHealthDeclaration';

export function MentalHealthReviewStep({ stepSchema }: { stepSchema: StepSchema }) {
  const { formService } = useFormContext();
  const step = formService.getFormData().steps.find((s) => s.id === stepSchema.id);

  if (!step || !formService.isActiveStep(step)) {
    return null;
  }

  return (
    <div className="step" id={stepSchema.id}>
      <p>
        Please check your information is correct before submitting your report.
        <br />
        To make changes, select an ‘Edit this section’ button below.
      </p>
      <Summary showReference={false} />
      <MentalHealthDeclaration />
    </div>
  );
}
